<template>
  <div class="container">
    <header>
      <video ref="video" class="video desktop" muted playsinline loop>
        <source src="../assets/schedule.mp4" type="video/mp4" />
      </video>
      <img class="mobile" src="../assets/schedule-header.svg" />
    </header>
    <img class="title" src="../assets/schedule-title.svg" />
    <nav>
      <router-link to="/schedule/elementary-school">國小</router-link>
      <router-link to="/schedule/junior-high-school">國中</router-link>
    </nav>
    <router-view />
  </div>
</template>

<script>
export default {
  mounted() {
    if (this.$mq == "desktop") {
      this.$refs.video.setAttribute("autoplay", true);
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  margin-bottom: 100px;

  .video {
    max-width: 1200px;
    width: 100%;
  }

  .title {
    margin: 40px auto;
    display: block;
    width: 160px;
  }

  nav {
    margin-bottom: 30px;
    display: flex;
    flex-direction: row;
    justify-content: center;

    a {
      margin: 0 60px;
      background-color: #f3f3f4;
      border-radius: 14px;
      text-decoration: none;
      color: #6b6b6b;
      font-size: 16px;
      font-weight: bold;
      padding: 10px 40px;

      &.router-link-active,
      &:hover {
        background-color: #c4cb7a;
        color: white;
      }
    }
  }
}

@media (max-width: 480px) {
  nav {
    a {
      margin: 0 15px !important;
      padding: 9px 25px !important;
      font-size: 12px !important;
    }
  }
}

@media (max-width: 1023px) {
  header img {
    width: 100%;
  }
}
</style>
